import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import FootyLab from './pages/FootyLab';
import Contact from './pages/Contact';
import Camp from './pages/Camp';
import Partners from './pages/Partners';
import Blog from './pages/Blog';
import Privacy from './pages/Privacy';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/footylab" element={<FootyLab />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/camp" element={<Camp />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/camp-registration" element={<Navigate to="/camp" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;